import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { isSubdomain } from '@/helpers/domian';
import { setSubdomainTheme } from '@/redux/theme/slice';
import { getSubdomainTheme } from '@/services/theme';

import { useAppSelector } from './redux';

const useGetSubdomainTheme = () => {
  const theme = useAppSelector(store => store.theme.subdomain);
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();
  useEffect(() => {
    if (Boolean(theme) || !isSubdomain()) {
      setIsLoading(false);
      return;
    }

    getSubdomainTheme()
      .then(theme => ({
        dark: theme?.default_color_theme_dark,
        light: theme?.default_color_theme_light
      }))
      .then(theme => {
        dispatch(setSubdomainTheme(theme));
      })
      .finally(() => setIsLoading(false));
  }, [dispatch, theme]);
  return { theme, isLoading };
};

export default useGetSubdomainTheme;
